<template>
    <div class="content_con">
        <p class="text-center">
            <span class="title">广东东进有害生物防控技术有限公司岗位承包采购项目</span>
        </p>
        <p class="text-center subtitle-container">
            <span class="title">成交结果公告</span>
        </p>
        <p class="text-indent-37 line-height-37 item">
            <span
                class="text"><span>本公司（广东东进有害生物防控技术有限公司）于2024年12月19日就广东东进有害生物防控技术有限公司岗位承包采购项目进行了竞争性磋商。现就本次采购的中标、成交结果公告如下：</span></span>
        </p>
        <p class="line-height-40 section-title">
            <span class="text">一、采购项目名称：广东东进有害生物防控技术有限公司岗位承包采购项目</span>
        </p>
        <p class="line-height-40 section-title">
            <span class="text">二、中标、成交供应商名称：</span>
        </p>
        <br>
        <p class="text-indent-37 line-height-37 item">
            <strong><span class="number">A1</span></strong>
            <strong><span class="text">包中标单位：</span></strong>
            <span class="text">第一名：广东亿锦园林绿化有限公司，成交不含税价为440.00 元；第二名：广东苏辰生态环境科技有限公司，成交不含税价为443.00
                元；第三名：广东碧然美景观艺术有限公司，成交不含税价为445.00元；并列第三名：东莞盈泓环保科技有限公司，成交不含税价为445.00 元；第四名：广州绿美生态林业有限公司，成交不含税价为446.00
                元。</span>
        </p>
        <p class="text-indent-37 line-height-37 item">
            <strong><span class="number">A2</span></strong>
            <strong><span class="text">包中标单位：</span></strong>
            <span class="text">第一名：东莞恒美园林绿化有限公司，成交不含税价为560.00 元；并列第一名：东莞市国旺有害生物防治有限公司，成交不含税价为560.00
                元；第二名：广东文康科技有限公司，成交不含税价为563.00 元；第三名：广东惠利民有害生物防制工程有限公司，成交不含税价为566.00元。</span>
        </p>
        <p class="text-indent-37 line-height-37 item">
            <strong><span class="number">A3</span></strong>
            <strong><span class="text">包中标单位：</span></strong>
            <span class="text">第一名：东莞市众艺堂有害生物防治有限公司，成交不含税价为630.00 元；第二名：深圳市元美环保科技有限公司，成交不含税价为635.00 元。</span>
        </p>
        <p class="line-height-40 section-title">
            <span class="section-title-text">三、评审日期：2024年12月19日</span>
        </p>
        <p class="text-indent-37 line-height-37 item">
            <span class="text">评审地点: 东莞市南城街道中天商业街28号1栋209室东进公司会议室</span>
        </p>
        <p class="text-indent-37 line-height-37 item">
            <span class="text">评审过程：由本公司磋商小组独立完成。</span>
        </p>

        <p class="line-height-40 section-title">
            <span class="section-title-text">四、本公告期限1个工作日</span>
        </p>
        <p class="line-height-40 section-title">
            <span class="section-title-text">五、联系事项</span>
        </p>
        <h2 class="text-indent-37 line-height-40 result">
            <span>单位名称：广东东进有害生物防控技术有限公司</span>
        </h2>
        <p class="text-indent-37 line-height-40 item">
            <span class="text">联系人：杨先生 </span>
        </p>
        <p class="text-indent-37 line-height-40 item">
            <span class="text">联系电话：</span>
            <span class="number">0769-22008298</span>
        </p>
        <p class="text-indent-37 line-height-40 item">
            <span class="text">邮箱地址：</span>
            <span class="number">3403006320@qq.com</span>
        </p>
        <p class="signature">
            <span class="content">发布人：广东东进有害生物防控技术有限公司</span>
        </p>
        <p class="signature">
            <span class="content">发布时间：</span>
            <span class="number">2024</span>
            <span class="content">年</span>
            <span class="number">12</span>
            <span class="content">月</span>
            <span class="number">24</span>
            <span class="content">日</span>
        </p>
        <p style="height:20px"></p>
        <p style="line-height: 16px;"><a class="group1 cboxElement"
                href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
                title=""><img style="vertical-align: middle; margin-right: 2px;"
                    src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"></a><a
                style="font-size:12px; color:#0066cc;" href="/20241203/03/广东东进有害生物防控技术有限公司岗位承包采购项目结果公示.pdf"
                title="广东东进有害生物防控技术有限公司岗位承包采购项目结果公示.pdf">广东东进有害生物防控技术有限公司岗位承包采购项目结果公示.pdf</a></p>
    </div>
</template>

<script>
export default {
  name: 'DocDisplay',
  data () {
    return {
      ahref: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.content_con {
    font-size: 14px;
    font-family: "宋体", Arial;
    padding: 0px 50px;
    color: #515050;

    a {
        text-decoration: none;
    }

    .text-center {
        text-align: center;
    }

    .subtitle-container {
        margin-bottom: 21px;
    }

    .line-height-2em {
        line-height: 2em;
    }

    .text-indent-37 {
        text-indent: 37px;
    }

    .line-height-37 {
        line-height: 37px;
    }

    .section-title {
        font-size: 19px;
        font-family: 黑体;
    }

    .item {
        font-size: 19px;
        font-family: 仿宋_GB2312;
    }

    .number {
        font-family: 'Times New Roman', 'serif';
    }

    .underline {
        text-decoration: underline;
    }

    .title {
        font-size: 27px;
        font-family: 方正小标宋简体;
    }

    .subtitle {
        font-size: 27px;
        font-family: 方正小标宋简体;
    }

    .text-autospace {
        margin: 3px;
        padding: 3px;

        span {
            color: #515050;
            font-size: 14px !important;
        }
    }

    .icon {
        margin-left: 5px;
        vertical-align: middle;
    }

    .file-link {
        text-align: left;
        font-size: 12px;
        color: #0066cc;
    }

    .line-height-40 {
        line-height: 40px;
    }

    .date {
        text-align: justify;
        text-justify: inter-ideograph;
        font-family: 'Times New Roman', 'serif';
        font-weight: normal;
    }

    .result {
        text-align: justify;
        text-justify: inter-ideograph;
        font-family: 仿宋_GB2312;
        font-weight: 200;
        font-size: 19px;

        .fa {
            font-size: 19px;
            font-family: 'Times New Roman', 'serif';
            font-weight: normal;
        }
    }

    .duration {
        text-align: justify;
        text-justify: inter-ideograph;
        font-family: 仿宋_GB2312;
        font-weight: normal;
    }

    .signature {
        font-size: 19px;
        line-height: 39px;
        font-family: 仿宋_GB2312;
        text-align: right;
    }
}
</style>
